import { useCallback } from "react";

interface Payload {
  upload_url: string;
  fileBlob: Blob;
}

const useUploadFileToS3Query = () => {
  const uploadFileToS3 = useCallback(async ({ upload_url, fileBlob }: Payload) => {
    const response = await fetch(upload_url, {
      method: 'PUT',
      headers: { 'x-amz-acl': 'private' },
      body: fileBlob,
    });
    return response;
  }, []);

  return {
    uploadFileToS3,
  };
};

export default useUploadFileToS3Query;
